// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__12my4","subheader":"ReorderModal_subheader__BvVes","listWrap":"ReorderModal_listWrap__4GEU2"};